const Parser = require("expr-eval").Parser
export const parser = new Parser()